import React from 'react';

const GetUpGetItDone = () => {
  return (
    <div className="bg-[#EDEDED] px-4 sm:px-6 xl:px-8 pt-10 pb-20 sm:py-20">
      <div className="text-center max-w-[1207px] w-full mx-auto">
        <h2 className="text-[#1D1D1F] text-[32px] sm:text-[50px] lg:text-[72px] leading-[40px] sm:leading-[60px] lg:leading-[130px] font-normal italic libre-baskerville mb-6">
          Get up Get it done
        </h2>
        <h1 className="text-[#1D1D1F] text-[32px] sm:text-[60px] lg:text-[100px] leading-[40px] sm:leading-[70px] lg:leading-[116.34px] font-normal libre-baskerville mb-6">
          Durable, Comfortable, Built to Perform.
        </h1>
      </div>
      <div className="mt-20 sm:mt-[100px] max-w-[1009px] mx-auto w-full flex items-center md:flex-row flex-col justify-between gap-10 md:gap-4">
        <div>
          <img src="/assets/curve-black-cover.webp" alt="curve-black-cover" />
        </div>
        <div className="max-w-[431px] w-full">
          <p className="text-[#1D1D1F] text-[20px] sm:text-[23px] leading-[30px] sm:leading-[40px] font-normal libre-baskerville">
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here',
          </p>
          <div className="mt-10 flex items-center gap-[9px]">
            <h3 className="text-[#1D1D1F] text-[17px] leading-[30px] font-medium">
              Discover Variations
            </h3>
            <button className="w-[27px] h-[27px] border border-[#0000004D] rounded-full flex items-center justify-center">
              <svg
                width="11"
                height="18"
                viewBox="0 0 11 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0583 8.84912C10.0583 8.98584 9.99976 9.11279 9.88257 9.22998L2.0896 17.0229C1.97241 17.1401 1.84546 17.1987 1.70874 17.1987C1.55249 17.1987 1.42554 17.1401 1.32788 17.0229L0.478271 16.1733C0.361084 16.0757 0.30249 15.9487 0.30249 15.7925C0.30249 15.6558 0.361084 15.5288 0.478271 15.4116L7.07007 8.84912L0.478271 2.25732C0.361084 2.14014 0.30249 2.01318 0.30249 1.87646C0.30249 1.72021 0.361084 1.59326 0.478271 1.49561L1.32788 0.645996C1.42554 0.528809 1.55249 0.470215 1.70874 0.470215C1.84546 0.470215 1.97241 0.528809 2.0896 0.645996L9.88257 8.43896C9.99976 8.55615 10.0583 8.69287 10.0583 8.84912Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetUpGetItDone;
